export default class QuestionCounter extends PIXI.Container {
    constructor() {
        super();

        this._icons = [];
        this._spacing = 40;
        this._index = 0;
        this._tweens = new P3.utils.TWEEN.Group();

        this._textures = {
            normal: P3.assets.texture("ui_icon_question_off"),
            selected: P3.assets.texture("ui_icon_question_current"),
            correct: P3.assets.texture("ui_icon_question_passed"),
            incorrect: P3.assets.texture("ui_icon_question_failed")
        };

        this.createIcons(10);

        this.setIndex(this._index);
    }

    update(dt) {
        this._tweens.update();
    }

    animateIn(training = false, callback, scope) {
        scope = scope || window;

        if (training) {
            let count = 0;
            for (let i = 0; i < this._icons.length; ++i) {
                const icon = this._icons[i];

                icon.alpha = 0;
                new P3.utils.TWEEN.Tween(icon, this._tweens)
                    .to({alpha: 1}, 440 * 0.4)
                    .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                    .delay(i * 340 * 0.4)
                    .onStart(() => {
                        icon.visible = true;
                    })
                    .onComplete(() => {
                        new P3.utils.TWEEN.Tween(icon.additive, this._tweens)
                            .to({alpha: 0}, 640 * 0.4)
                            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                            .onComplete(() => {
                                icon.additive.visible = false;
                            })
                            .start();

                        if (++count >= this._icons.length) {
                            for (let i = 0; i < this._icons.length; ++i) {
                                const icon = this._icons[i];

                                if (i < 3) {
                                    new P3.utils.TWEEN.Tween(icon, this._tweens)
                                        .to({x: i * this._spacing - (this._spacing * (3 - 1)) * 0.5}, 440)
                                        .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                                        .delay(1400)
                                        .start();
                                } else {
                                    new P3.utils.TWEEN.Tween(icon, this._tweens)
                                        .to({alpha: 0}, 420)
                                        .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                                        .delay(1000)
                                        .onComplete(() => {
                                            icon.visible = false;
                                        })
                                        .start();
                                }
                            }
                        }
                    })
                    .start();
            }
        } else {
            let count = 0;
            for (let i = 0; i < this._icons.length; ++i) {
                const icon = this._icons[i];

                icon.alpha = 0;
                new P3.utils.TWEEN.Tween(icon, this._tweens)
                    .to({alpha: 1}, 440)
                    .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                    .delay(i * 340 * 0.4)
                    .onStart(() => {
                        icon.visible = true;
                    })
                    .onComplete(() => {
                        new P3.utils.TWEEN.Tween(icon.additive, this._tweens)
                            .to({alpha: 0}, 640 * 0.4)
                            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                            .onComplete(() => {
                                icon.additive.visible = false;
                            })
                            .start();

                        if (++count >= this._icons.length) {
                            callback && callback.call(scope);
                        }
                    })
                    .start();
            }
        }
    }

    createIcons(count) {
        for (let i = 0; i < count; ++i) {
            const icon = new PIXI.Sprite(this._textures.normal);
            icon.position.set(i * this._spacing - (this._spacing * (count - 1)) * 0.5, 0);
            icon.anchor.set(0.5);
            icon.visible = false;
            this.addChild(icon);

            icon.additive = new PIXI.Sprite(this._textures.normal);
            icon.additive.anchor.set(0.5);
            icon.additive.blendMode = PIXI.BLEND_MODES.ADD;
            icon.addChild(icon.additive);

            this._icons.push(icon);
        }
    }

    next() {
        let index = this._index;
        index < this._icons.length - 1 && this.setIndex(++index, false);
    }

    previous() {
        let index = this._index;
        index > 0 && this.setIndex(--index, false);
    }

    setIndex(index, reset = true) {
        const last = this._icons[this._index];
        reset && (last.texture = this._textures.normal);

        let icon = this._icons[this._index];
        icon.tween && icon.tween.stop();

        icon.tween = new P3.utils.TWEEN.Tween(icon.scale, this._tweens)
            .to({x: 1, y: 1}, 340)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .start();

        this._index = index;

        icon = this._icons[this._index];
        icon.texture = this._textures.selected;

        icon.tween = new P3.utils.TWEEN.Tween(icon.scale, this._tweens)
            .to({x: 1.14, y: 1.14}, 1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .repeat(Infinity)
            .yoyo(true)
            .start();
    }

    setAnswerIndex(correct, index) {
        const icon = this._icons[index];
        icon.texture = correct ? this._textures.correct : this._textures.incorrect;

        icon.tween && icon.tween.stop();

        const a = new P3.utils.TWEEN.Tween(icon.scale, this._tweens)
            .to({x: 1.4, y: 1.4}, 180);

        const b = new P3.utils.TWEEN.Tween(icon.scale, this._tweens)
            .to({x: 1, y: 1}, 240)
            .easing(P3.utils.TWEEN.Easing.Back.Out);

        a.chain(b);
        a.start();
    }

    setAnswer(correct) {
        this.setAnswerIndex(correct, this._index);
    }

    get index() {
        return this._index;
    }
}